import * as actions from "../action.constants";

const updateAdduserModal = (data) => ({
  type: actions.SAVE_ADD_USER_MODAL_STATUS,
  payload: data,
});

const updateAdduserModalData = (data) => ({
  type: actions.SAVE_ADD_USER_MODAL_DATA,
  payload: data,
});
const sendAdduserModalData = (data, callback) => ({
  type: actions.REQUEST_SEND_ADD_USER_DATA_SAGA,
  payload: data,
  callback,
});
const requestUsers = (pageUrl) => ({
  type: actions.REQUEST_GET_USERS_LIST_SAGA,
  pageUrl,
});
const saveUsersList = (data) => ({
  type: actions.SAVE_GET_USERS_LIST,
  payload: data,
});

const sendEditUserModalData = (data, callback) => ({
  type: actions.REQUEST_SEND_EDIT_USER_DATA_SAGA,
  payload: data,
  callback,
});

const deleteUserData = (id, callback) => ({
  type: actions.REQUEST_DELETE_USER_SAGA,
  payload: id,
  callback,
});

const requestUserProfile = () => ({
  type: actions.GET_USER_PROFILE,
});

const saveUserProfile = (data) => ({
  type: actions.STORE_USER_PROFILE,
  payload: data,
});

const saveGroups = (responsePayload) => ({
  type: actions.SAVE_GROUP_LIST,
  responsePayload,
});

export const verifyPhoneNumber = (data, callback) => ({
  type: actions.VERIFY_PHONE_NUMBER,
  payload: data,
  callback,
});

export {
  updateAdduserModal,
  updateAdduserModalData,
  sendAdduserModalData,
  requestUsers,
  saveUsersList,
  sendEditUserModalData,
  deleteUserData,
  requestUserProfile,
  saveUserProfile,
  saveGroups,
};
